import React from 'react';
import { Form, DatePicker } from 'antd';

const UntilItem = ({ rootContainer, disabled, required, shouldUpdate }) => {
  return (
    <Form.Item shouldUpdate={shouldUpdate} name={['rules', 'until']} rules={[{ required: required, message: 'Required' }]}>
      <DatePicker disabled={disabled} style={{ width: '50%' }} format="YYYY-MM-DD" getPopupContainer={rootContainer} />
    </Form.Item>
  );
};
export default UntilItem;
